var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.186 5.86L1.13 1.582A1 1 0 0 1 1.943 0h6.114a1 1 0 0 1 .814 1.581l-3.057 4.28a1 1 0 0 1-1.628 0z","fill":"#151049","fillRule":"evenodd"}));
}

Arrow.defaultProps = {"width":"10","height":"7"};

module.exports = Arrow;

Arrow.default = Arrow;
